module.exports = __webpack_public_path__ + "assets/img/thumb-Found-Concrete-Video.361ae98a.jpg";